export const PortfolioConfig = {
    name            : 'Portfolio',
    icon            : 'ii5-assets',
    // iconLight       : 'i5-tasks-light',
    image           : 'portfolio2',
    iconSvg         : 'isvg-view-portfolio',
    url             : 'portfolio',
    stringId        : 'portfolio',
    description     : 'Custom projects portfolio with progress and status.',
    canBeInProject  : true,
}

export const PROJECTS_PORTFOLIO_CONFIG = {
    ...PortfolioConfig,
    // key2: "newValue2",  // Replacing the value for key2
}
